import { Doc } from "../../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";

// `alertType` es un filtro semántico que mapea a flags booleanos calculados (no campo del doc).
export const stockAlertTypeRule: FilterRule<Doc<"stock_status">> = {
  priority: 3,
  build: async (
    ctx: FilterRuleCtx,
    args: Partial<Omit<Doc<"stock_status">, "_id" | "_creationTime">>,
  ) => {
    const alertType = (args as any).alertType as string | undefined;

    if (!alertType || alertType === "all") return undefined;

    const { userContext } = ctx;
    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const rows = await ctx.db
      .query("stock_status")
      .withIndex("by_company_id", (q) =>
        q.eq("internalControl.companyId", userContext.companyId!),
      )
      .collect();

    const scopedRows = userContext.branchId
      ? rows.filter((row) => row.internalControl.branchId === userContext.branchId)
      : rows;

    switch (alertType) {
      case "low_stock":
        return scopedRows.filter((r) => r.isLowStock === true);
      case "out_of_stock":
        return scopedRows.filter((r) => r.isOutOfStock === true);
      case "damaged":
        return scopedRows.filter((r) => r.hasDamagedItems === true);
      case "expired":
        return scopedRows.filter((r) => r.hasExpiredItems === true);
      default:
        return undefined;
    }
  },
};
